import script from "./CartLink.vue?vue&type=script&lang=ts&setup=true"
export * from "./CartLink.vue?vue&type=script&lang=ts&setup=true"

import "./CartLink.vue?vue&type=style&index=0&id=eebb1e12&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eebb1e12"]])

export default __exports__